const InView = require('inview');
/**
 * Counter component.
 * All DOM elements with class `.js-counter` will start counting on page load.
 *
 * Usage:
 * Call counter.init() to initialize all $counters.
 *
 * Methods:
 *
 * init(): attaches eventlisteners to all $counters
 */

const $counters = document.querySelectorAll('.js-counter');

const countLengthInS = 2;
const countLengthInMs = countLengthInS * 1000;
const start = 1;

function formatNumber(num, separator) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`);
}

const setupCounter = $el => {
	const loops = Math.floor(Math.random() * 100) + 80; // returns a random integer from 80 to 100
	const end = $el.getAttribute('data-counter');
	const separator = $el.getAttribute('data-counter-separator');

	const step = end / loops;
	const interval = countLengthInMs / loops;
	let curval = start;

	$el.innerHTML = curval;

	const myInterval = window.setInterval(() => {
		if (curval + step >= end) {
			window.clearInterval(myInterval);
			$el.innerHTML = formatNumber(end, separator);
		} else {
			curval += step;
			$el.innerHTML = formatNumber(Math.round(curval), separator);
		}
	}, interval);
};

const counter = () => {
	if ($counters.length > 0) {
		$counters.forEach($el => {
			InView($el, function(isInView, data) {
				if (isInView) {
					if (data.elementOffsetTopInViewHeight < data.inViewHeight - 200) {
						setupCounter($el);
						this.destroy();
					}
				}
			});
		});
	}
};

module.exports = {
	init: counter
};
